<template>
    <div class="container" :style="containerStyleObj">
        <Row class="title-wrap" :style="titleWrapStyleObj" ref="titleWrap">
            <Col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }">
            <div class="title" :style="titleStyleObj">
                <img src="../../assets/images/databoard/head-left-icon.png" />
                <span v-on:click="handleFullScreen()">{{
                    schoolData.school_name
                }}</span>
                <img src="../../assets/images/databoard/head-right-icon.png" />
            </div>
            <div class="logo" :style="logoStyleObj">
                <template>
                    <img :src="`${logoPath}?${timestamp}`" />
                    <span class="split-line"></span>
                    <img src="../../assets/images/databoard/ai-logo.png" style="margin: 3.5px 0" />
                </template>
            </div>
            <div class="full-screen" v-on:click="handleFullScreen()">
                <template v-if="!fullscreen">
                    <span class="full-icon"><img src="../../assets/images/databoard/full-screen-icon.png" /></span>
                    <span class="full-title">全屏</span>
                </template>
                <template v-else>
                    <span class="full-icon"><img src="../../assets/images/databoard/exit-full-screen-icon.png" /></span>
                    <span class="full-title">取消全屏</span>
                </template>
            </div>
            </Col>
        </Row>
        <Row :gutter="20" class="statistic-wrap" :style="statisticWrapStyleObj">
            <Col :xs="{ span: 6 }" :sm="{ span: 6 }" :md="{ span: 6 }" :lg="{ span: 6 }" style="padding-right: 0px">
            <!--各学段资源存量-->
            <ebook-statis :ebookCountList="resourseList" :titleHeight="titleHeight" :screenHeight="screenHeight" :id="1">
            </ebook-statis>
            <!--资源类型分布-->
            <courseware-statis :teaCourseware="resourceType"  :titleHeight="titleHeight" :screenHeight="screenHeight"  :id="2"></courseware-statis>
            <!-- 资源分享学校排行TOP3 -->
            <answer-inter-analysis :list="resourceSharing" :titleHeight="titleHeight" :screenHeight="screenHeight"  :id="3"></answer-inter-analysis>
            </Col>


            <Col :xs="{ span: 12 }" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <div class="statis-count" :style="statisCountStyleObj">
                <Col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }">
                <div class="count-wrap">
                    <ul>
                        <li style="width: 25%;" >
                            <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                                :nameStyleObj="nameStyleObj" :end-val="schoolData.construct_num" intro-text="建设资源总量"
                                cardType="dataSupervise" :isConvert="isConvert"></infor-card>
                            <span class="right-border"></span>
                        </li>
                        <li style="width: 25%;" >
                            <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                                :nameStyleObj="nameStyleObj" :end-val="schoolData.res_num" intro-text="资源应用总量"
                                cardType="dataSupervise" :isConvert="isConvert"></infor-card>
                            <span class="right-border"></span>
                        </li>
                        <li style="width: 25%;" >
                            <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                                :nameStyleObj="nameStyleObj" :end-val="schoolData.sch_sum" intro-text="覆盖学校数"
                                cardType="dataSupervise" :isConvert="isConvert"></infor-card>
                                <span class="right-border"></span>
                        </li>
                        <li style="width: 25%;" >
                            <infor-card class="data-sur-count-card" style="cursor: pointer" :numStyleObj="numStyleObj"
                                :nameStyleObj="nameStyleObj" :end-val="schoolData.tea_num" intro-text="覆盖教师数"
                                cardType="dataSupervise" :isConvert="isConvert"></infor-card>
                        </li>
                    </ul>
                </div>
                </Col>
            </div>
            <!-- 实时操作动态 -->
            <div class="tea-oper-dym" :style="teaOperDymStyleObj">
                <span class="border-left-top"></span>
                <span class="border-left-bottom"></span>
                <span class="border-right-top"></span>
                <span class="border-right-bottom"></span>
                <div class="statis-title bg1">
                    <span>实时操作动态</span>
                </div>
                <div class="dym-content" :style="dymContentStyleObj">
                    <tea-dynamic :dynamicData="dynamicData" ref="dynamicRef"></tea-dynamic>
                </div>
            </div>
            <!-- 资源访问量 -->
            <pie-item name="teaBehavior" :titleHeight="titleHeight" :paramTeaData="resourceAccess"
                  :screenHeight="screenHeight"></pie-item>
            </Col>

            <Col :xs="{ span: 6 }" :sm="{ span: 6 }" :md="{ span: 6 }" :lg="{ span: 6 }" style="padding-right: 0px">
            <!--各学段资源应用情况-->
            <ebook-statis :ebookCountList="useresourseList" :titleHeight="titleHeight" :screenHeight="screenHeight" :id="4">
            </ebook-statis>
            <!--各学科资源应用情况-->
            <courseware-statis :teaCourseware="useteaCourseware" :teaCoursewareCount="teaCoursewareCount"
                :titleHeight="titleHeight" :screenHeight="screenHeight" :id="5"></courseware-statis>
            <!-- 资源应用学校排行TOP3 -->
            <answer-inter-analysis :list="useanswerInterBehavior" :titleHeight="titleHeight" :screenHeight="screenHeight" :id="6"></answer-inter-analysis>
            </Col>

        </Row>
    </div>
</template>
  
<script>
import inforCard from "../../components/inforCard.vue"; //数据卡片
import ebookStatis from "./modules/ebookStatis";
import coursewareStatis from "./modules/coursewareStatis";
import teaDynamic from "./modules/teaDynamic.vue";
import answerInterAnalysis from "./modules/answerInterAnalysis";
import pieItem from "./modules/pieItem";
import axios from 'axios'
export default {
    name: "gx-index",
    components: {
        inforCard, //数据卡片
        ebookStatis,
        coursewareStatis,
        teaDynamic,
        pieItem,
        answerInterAnalysis
    },
    computed: {},
    data() {
        return {
            isConvert: 1, //是否转换数字
            fullscreen: false,
            schoolData: {},
            newSchoolData: {},
            evlPer: 80,
            teaCourseware: [], //教师课件
            stuHomework: [], //学生作业
            teaClassBehavior: [], //教师课堂行为
            dynamicData: [], //实时操作动态
            baseData: [], //基础数据
            classInteractData: [], //课堂互动
            classInteractTotal: 0, //课堂互动总数
            teaBehaviorData: [], //教师行为
            stuBehaviorData: [], //学生行为
            resourseList: [], //各学段资源存量
            resourceType:[],//资源类型分布
            resourceSharing:[],// 资源分享学校排行TOP3
            resourceAccess:[],//资源访问量
            useresourseList:[],//各学段资源应用量
            useteaCourseware:[],//资源类型应用分布
            useanswerInterBehavior:[],// 资源应用分享学校排行TOP3
            top: [],
            left: [130, 140, 150, 160, 170, 180, 190, 200, 210, 230],
            color: ["#FFF", "#00d8ff", "#ffce23"],
            scrollInterval: {}, //动态滚动区间,
            scrollIngDynamicList: [],
            screenHeight: document.body.clientHeight, // 屏幕默认宽度
            containerStyleObj: {
                height: "",
            },
            titleWrapStyleObj: {
                height: "",
            },
            titleStyleObj: {
                height: "",
            },
            logoStyleObj: {
                height: "",
            },
            statisticWrapStyleObj: {
                height: "",
                margin: "0px 0px 10px 0px",
            },
            statisCountStyleObj: {
                height: "",
            },
            numStyleObj: {
                height: "",
                lineHeight: "",
            },
            nameStyleObj: {
                height: "",
                lineHeight: "",
            },
            teaOperDymStyleObj: {
                height: "",
            },
            dymContentStyleObj: {
                height: "",
            },
            teaCoursewareCount: "", //教师课件总数
            titleHeight: 0,
            schoolId: this.$route.params.schoolId, //学校id
            logoPath: process.env.VUE_APP_DASH_LOGO_PATH,
            timestamp: new Date().getTime(),
        };
    },
    created() { },
    watch: {},
    methods: {
        getData() {
            let currentPath = this.$route.path;
            let url = currentPath == '/hsdataboard'?`https://fs.iclass30.com/aliba/dashboard/hsdataboard.json?v=${Date.now()}`:`https://fs.iclass30.com/aliba/dashboard/gxdataboard.json?v=${Date.now()}`
            axios.get(url)
                .then(res => {
                    this.schoolData = res.data 
                    this.resourseList =  this.schoolData.resourseList;
                    //获取课件统计
                    this.resourceType =  this.schoolData.resourceType;
                    this.dynamicData =  JSON.parse(res.data.dynamic);
                    this.resourceSharing = res.data.resourceSharing
                    this.resourceAccess = res.data.resourceAccess
                    this.useanswerInterBehavior = res.data.useanswerInterBehavior
                    this.useteaCourseware = res.data.useteaCourseware
                    this.useresourseList = res.data.useresourseList
                })
                .catch(error => {
                    this.$Message.error(error.message);
                });
        },
        /**
         * 全屏
         */
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        },
    },
    mounted() {
        const _this = this;
        this.$nextTick(() => {
            let windowHeight = window.innerHeight;
            if (windowHeight < 900) {
                windowHeight = 938;
                document.getElementsByTagName("body")[0].className = "active";
            }
            let titleHeight = 128;
            let statisticHeight = windowHeight - titleHeight - 10;
            let statisHeight = windowHeight / 12.5;
            let dymHeight = statisticHeight - statisHeight - statisticHeight / 3 - 20;
            this.titleHeight = titleHeight;
            this.containerStyleObj.height = windowHeight + "px";
            this.titleWrapStyleObj.height = titleHeight + "px";
            this.titleStyleObj.height = titleHeight * 0.4 - 10 + "px";
            this.logoStyleObj.height = titleHeight * 0.3 + "px";
            this.statisticWrapStyleObj.height = statisticHeight + "px";
            this.statisCountStyleObj.height = statisHeight + "px";
            this.numStyleObj.height = statisHeight * 0.6 + "px";
            this.numStyleObj.lineHeight = statisHeight * 0.6 + "px";
            this.nameStyleObj.height = statisHeight * 0.4 + "px";
            this.nameStyleObj.lineHeight = statisHeight * 0.4 + "px";
            this.teaOperDymStyleObj.height = dymHeight + "px";
            this.dymContentStyleObj.height = dymHeight - 49 + "px";
            //获取数据展板所有统计数据
            this.getData()
        });

        // 注：window.onresize只能在项目内触发1次
        window.onresize = function windowResize() {
            // 通过捕获系统的onresize事件触发我们需要执行的事件
            let windowHeight = document.body.clientHeight;
            if (windowHeight < 900) {
                windowHeight = 938;
                document.getElementsByTagName("body")[0].className = "active";
            }
            _this.screenHeight = windowHeight;
            let titleHeight = 128;
            let statisticHeight = windowHeight - titleHeight - 10;
            let statisHeight = windowHeight / 12.5;
            let dymHeight = statisticHeight - statisHeight - statisticHeight / 3 - 20;
            _this.titleHeight = titleHeight;
            _this.titleHeight = titleHeight;
            _this.containerStyleObj.height = windowHeight + "px";
            _this.titleWrapStyleObj.height = titleHeight + "px";
            _this.titleStyleObj.height = titleHeight * 0.4 - 10 + "px";
            _this.logoStyleObj.height = titleHeight * 0.3 + "px";
            _this.statisticWrapStyleObj.height = statisticHeight + "px";
            _this.statisCountStyleObj.height = statisHeight + "px";
            _this.numStyleObj.height = statisHeight * 0.6 + "px";
            _this.numStyleObj.lineHeight = statisHeight * 0.6 + "px";
            _this.nameStyleObj.height = statisHeight * 0.4 + "px";
            _this.nameStyleObj.lineHeight = statisHeight * 0.4 + "px";
            _this.teaOperDymStyleObj.height = dymHeight + "px";
            _this.dymContentStyleObj.height = dymHeight - 49 + "px";
        };
    },
};
</script>
  
<style lang="scss" scoped>
@import "../../style/databoard";
@import "../../style/detailPage";

.panel-box {
    background-image: url("../../assets/images/databoard/modal-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

@font-face {
    font-family: MaravaleExpanded;
    src: url("../../assets/fonts/digifaw.ttf"); //字体路径
}

.container {
    background-image: url("../../assets/images/databoard/bg.png");
    background-size: cover;
    background-repeat: no-repeat;
}

.title-wrap {
    background-image: url("../../assets/images/databoard/head-bg.png");
    background-repeat: no-repeat;
    background-position: top;
}

.count-wrap {
    height: 100%;
    background-image: url("../../assets/images/databoard/count-bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.full-screen {
    background-image: url("../../assets/images/databoard/full-screen-bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.statis-report {
    background-image: url("../../assets/images/databoard/full-screen-bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.bg1 {
    background-image: url("../../assets/images/databoard/title-bg1.png");
}
</style>
  
<style lang="scss">
body {
    background-color: #000 !important;
    overflow-x: hidden;
    overflow-y: hidden;
}

.active {
    overflow-x: auto;
    overflow-y: auto;
}
</style>
  